import React from 'react';

const ShoppingBag = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.273 28">
        <path
            fill="currentColor"
            fillRule="nonzero"
            stroke="currentColor"
            d="M5.957 7.981V5.9C5.957 2.926 8.267.5 11.136.5s5.179 2.426 5.179 5.4V7.98h3.58a.65.65 0 0 1 .646.606l1.23 18.22a.653.653 0 0 1-.602.693H1.146a.648.648 0 0 1-.646-.65v-.043l1.23-18.22a.65.65 0 0 1 .647-.608l3.58.002Zm1.943 0h6.474V5.9c0-1.913-1.45-3.448-3.238-3.448S7.9 3.986 7.9 5.899v2.082Zm-5.368 17.57H19.74L18.687 9.934h-15.1L2.532 25.551Z"
        />
    </svg>
);

export default ShoppingBag;
